// ** List of freeze Orders  */
export const LIST_FREEZEORDER_INITIATED = "LIST_FREEZEORDER_INITIATED";
export const LIST_FREEZEORDER_SUCCESS = "LIST_FREEZEORDER_SUCCESS";
export const LIST_FREEZEORDER_FAILED = "LIST_FREEZEORDER_FAILED";

// ** reset error
export const RESET_ERRORS = "RESET_ERRORS";
